import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { Avatar, Col, Row, Skeleton, Tabs } from "antd";
import Curriculumloader from "../../../../../components/dashboardpages/loaders/curriculumloader/curriculumloader";
import { getClass } from "../../../../../api/class/class";
import { openNotificationWithIcon } from "../../../../../utils/helper";
import { RootState } from "../../../../../store/store";
import { useSelector } from "react-redux";
import {
  getCurriculum,
  getCurriculumAssignment,
} from "../../../../../api/curriculum/curriculum";
import Modulegroup from "../../../teacher/teachercurricula/teachercurriculum/modulegroup/modulegroup";
import { getClassLeaderBoard } from "../../../../../api/classleaderboard/classleaderboard";

const percentage: number = 0;


const Studentclass = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line
  const { classId } = useParams();

  // eslint-disable-next-line
  const [curriculumDetails, setCurriculumDetails] = useState<any>({});
  const [curriculumMainDetails, setCurriculumMainDetails] = useState<any>({});
  const [loadingCurriculumDetails, setLoadingCurriculumDetails] =
    useState(false);
  const [teachers, setTeachers] = useState<any>([]);
  const [classCurriculumAssignment, setClassCurriculumAssignment] = useState<
    any[]
  >([]);
  // eslint-disable-next-line
  const [loadingAssignment, setLoadingAssignment] = useState(true);
  const [loading, setLoading] = useState(false);
  const [classDetails, setClassDetails] = useState<any>({});
  const [currentCurriculumId, setCurrentCurriculumId] = useState("");

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;



  useEffect(() => {
    navigate(`${pathname}`, {
      state: {
        pageName: "Classes",
      },
    });

    // eslint-disable-next-line
  }, []);

  const fetchCurriculum = async (curriculumId: string) => {
    try {
      setLoadingCurriculumDetails(true);
      const res = await getCurriculum(curriculumId || "");
      const { data } = res?.data;
      setCurriculumMainDetails(data);
      const newData: any[] = [];
      data.modules.forEach((item: any, index: number) => {
        let obj = {
          ...item,
          open: index === 0 ? true : false,
        };
        newData.push(obj);
      });
      setCurriculumMainDetails((prevState: any) => ({
        ...prevState,
        data: newData,
      }));
      setLoadingCurriculumDetails(false);
    } catch (error: any) {
      setLoadingCurriculumDetails(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Curriculum",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Get Curriculum",
          "Something went wrong"
        );
      }
    }
  };

  const fetchClassAssignment = async () => {
    try {
      setLoadingAssignment(true);
      const res = await getCurriculumAssignment({
        classId,
        assigneeId: user?._id,
      });

      const { data } = res?.data;
      const newCurriculum: any[] = [];
      data.forEach((item: any) => {
        newCurriculum.push({
          ...item,
          key: item._id,
          label: item.curriculumId.name,
        });
      });
      setClassCurriculumAssignment(newCurriculum);
      setCurrentCurriculumId(newCurriculum[0].key);
      setCurriculumDetails(newCurriculum[0]);
      fetchCurriculum(newCurriculum[0].curriculumId._id);
      setLoadingAssignment(false);
    } catch (error: any) {
      console.log(error);
      setLoadingAssignment(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Class Curriculum Assignment",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Class Curriculum Assignment",
          "Something went wrong"
        );
      }
    }
  };

//   const fetchClassLeaderboard = async (classId: string) =>{
//     try {
//       setLoading(true)
//       const res = await getClassLeaderBoard({classId});
//       console.log(res)
//       setLoading(false)
//     }
//   catch (error: any) {
//     setLoading(false);
//     if (error?.response) {
//       openNotificationWithIcon(
//         "error",
//         "Get Leaderboard",
//         `${error?.response?.data?.message || "Something went wrong"}`
//       );
//     } else {
//       openNotificationWithIcon("error", "Get Leaderboard", "Something went wrong");
//     }
//   }
// }

  const fetchClass = async () => {
    try {
      setLoading(true);
      const res = await getClass(classId || "");
      const { data } = res?.data;
      setClassDetails(data);
      let newTeachers = [];
      newTeachers.push({
        ...data.teacherId,
        isAdminTeacher: true,
      });
      data.subTeachers.forEach((item: any) => {
        newTeachers.push({
          ...item.teacherId,
          isAdminTeacher: false,
        });
      });
      setTeachers(newTeachers);
      setLoading(false);
      fetchClassAssignment();
    } catch (error: any) {
      setLoading(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Class",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon("error", "Get Class", "Something went wrong");
      }
      navigate(`/student/dashboard/classes`);
    }
  };

  useEffect(() => {
    fetchClass();
    if (classId) {
      // fetchClassLeaderboard(classId);
    }
    // eslint-disable-next-line
  }, [classId]);

  const setDefaultCurriculum = async (curriculumId: string) => {
    const selectedCurriculum = classCurriculumAssignment.filter(
      (item) => item.key === curriculumId
    );
    setCurriculumDetails(selectedCurriculum[0]);
    setCurrentCurriculumId(curriculumId);

    fetchCurriculum(selectedCurriculum[0].curriculumId._id);
  };

  const openLevel = (levelIndex: number, value: boolean) => {
    let updatedLevels: any = [...curriculumMainDetails.data];
    let newLevels = updatedLevels.map((item: any, index: number) => {
      if (index === levelIndex) {
        return {
          ...item,
          open: value,
        };
      }

      return {
        ...item,
        open: false,
      };
    });

    setCurriculumMainDetails((prevState: any) => ({
      ...prevState,
      data: newLevels,
    }));
  };


  return (
    <div className="h-screen pr-10 mt-4 mb-10">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center">
          <div
            className="flex w-fit cursor-pointer items-center justify-center rounded-xl bg-appcolorgreyfaint p-[0.5rem]"
            onClick={() => {
              navigate(`/student/dashboard/classes`);
            }}
          >
            <LeftOutlined />
          </div>
          <p className="pl-[0.6rem] text-2xl font-[900] capitalize text-appcolorpurplefaintone">
            {loading ? (
              <Skeleton.Button
                active={true}
                size={"large"}
                shape={"square"}
                block={true}
                style={{
                  height: "2rem",
                  width: "6rem",
                }}
              />
            ) : (
              classDetails?.name
            )}
          </p>
        </div>
        <div>
          <div className="custom-box-shadow-five flex cursor-pointer items-center justify-center rounded-xl bg-appcolorgreyfaint p-[0.5rem]">
            <img
              src="/img/vectors/blackmore.svg"
              className="h-[0.8rem] w-[0.8rem]"
              alt="more"
            />
          </div>
        </div>
      </div>

      <div>
        <Row gutter={16}>
          <Col xs={24} md={24} lg={12}>
            <div className="mb-10 max-h-[90vh] min-h-[90vh] overflow-auto pb-10">
              <div className="custom-primary-bg-six mb-[1.5rem] flex justify-center rounded-[1.8rem] py-[0.6rem]">
                <img
                  src={`/img/vectors/${
                    classDetails?.languageId?.name?.toLowerCase() === "python"
                      ? "classpython.svg"
                      : "classnormal.svg"
                  }`}
                  alt="classpython"
                  className="h-[8.1rem] w-[14.3rem]"
                />
              </div>

              <div>
                <div className="flex items-center mb-4">
                  <p className="pr-3 text-base font-medium text-appcolorgrey ">
                    Class Code:
                  </p>
                  <div className="flex-1">
                    <img
                      src="/img/vectors/dotted.svg"
                      alt="dotted"
                      className="w-full"
                    />
                  </div>
                  <div className="flex items-center pl-3">
                    <span className="pr-2 text-sm font-medium text-appcolorpurplefive">
                      {classDetails?.code}
                    </span>
                    <img
                      src="/img/vectors/purplecopy.svg"
                      alt="purplecopy"
                      className="h-[1rem] w-[1rem]"
                    />
                  </div>
                </div>

                <div className="flex items-center mb-4">
                  <p className="pr-3 text-base font-medium text-appcolorgrey ">
                    Class Link:
                  </p>
                  <div className="flex-1">
                    <img
                      src="/img/vectors/dotted.svg"
                      alt="dotted"
                      className="w-full"
                    />
                  </div>
                  <div className="flex items-center pl-3">
                    <span className="pr-2 text-sm font-medium text-appcolorpurplefive">
                      Share Class
                    </span>
                    <img
                      src="/img/vectors/purpleshare.svg"
                      alt="purpleshare"
                      className="h-[1rem] w-[1rem]"
                    />
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-appcolorpurplefive ">
                <div className="flex items-center mb-4">
                  <p className="pr-3 text-base font-medium text-appcolorgrey ">
                    Students
                  </p>
                  <div className="flex-1">
                    <img
                      src="/img/vectors/dotted.svg"
                      alt="dotted"
                      className="w-full"
                    />
                  </div>
                  <div className="flex items-center pl-3">
                    <img
                      src="/img/vectors/classcarduser.svg"
                      alt="purpleshare"
                      className="h-[1rem] w-[1rem]"
                    />
                    <span className="pl-2 text-sm font-medium text-appcolorpurplefaintone">
                      {classDetails?.students?.length}
                    </span>
                  </div>
                </div>

                <div className="flex items-center mb-4">
                  <p className="pr-3 text-base font-medium text-appcolorgrey ">
                    Minimum Funpoints Goal
                  </p>
                  <div className="flex-1">
                    <img
                      src="/img/vectors/dotted.svg"
                      alt="dotted"
                      className="w-full "
                    />
                  </div>
                  <div className="flex items-center pl-3">
                    <img
                      src="/img/vectors/star.svg"
                      alt="purpleshare"
                      className="h-[1rem] w-[1rem]"
                    />
                    <span className="pl-2 text-sm font-medium text-appcolorpurplefaintone">
                      0
                    </span>

                    <div className="relative ml-2 items-center rounded-[1rem] bg-appcoloryellowfaintthree px-3 py-1">
                      <p className="relative z-[1] text-sm font-medium text-appcoloryellowtwo">
                        0 earned
                      </p>
                      <div
                        className="absolute top-0 left-0 bg-appcoloryellowfainttwo"
                        style={{
                          width: `${percentage}%`,
                          height: "1.7rem",
                          borderTopRightRadius: percentage === 100 ? "1rem" : 0,
                          borderBottomRightRadius:
                            percentage === 100 ? "1rem" : 0,
                          borderTopLeftRadius: "1rem",
                          borderBottomLeftRadius: "1rem",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-12">
                <div className="flex justify-between mb-4">
                  <p className="text-xl font-bold capitalize text-appcolorblackfainteleven">
                    Teachers
                  </p>
                </div>

                <div>
                  {loading ? (
                    [1, 3, 4].map((item) => (
                      <Skeleton.Button
                        key={`loading-teachers-${item}`}
                        active={true}
                        size={"large"}
                        shape={"square"}
                        block={true}
                        style={{
                          height: "4rem",
                          width: "100%",
                          marginBottom: "1rem",
                        }}
                      />
                    ))
                  ) : (
                    <div>
                      {teachers?.length === 0 ? (
                        <>
                          <p className="tex-base text-appcolorblackfainteleven">
                            Leaderboard data currently unavailable
                          </p>
                        </>
                      ) : (
                        teachers.map((item: any) => (
                          <div className="flex items-center mb-3">
                            <img
                              src={`${
                                item?.userAvatarURL === undefined
                                  ? "/img/vectors/usertag.svg"
                                  : item?.userAvatarURL === ""
                                  ? "/img/vectors/usertag.svg"
                                  : item?.userAvatarURL
                              }`}
                              alt="usertag"
                              className="w-8 h-8 pr-2"
                            />
                            {/* <img src="/img/logo/cfhcircle.svg" alt="cfhcircle"  /> */}
                            <span>
                              {item.firstName} {item.lastName}
                            </span>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-12">
                <p className="mb-2 text-xl font-bold capitalize text-appcolorblackfainteleven">
                  Classroom Leaderboard
                </p>

                <p className="mb-2 text-base">
                  See how you’re doing in your class
                </p>

                <div>
                  {loading ? (
                    <>
                      {[3, 4, 5].map((item) => (
                        <Skeleton.Button
                          key={`loading-students-${item}`}
                          active={true}
                          size={"large"}
                          shape={"square"}
                          block={true}
                          style={{
                            height: "4rem",
                            width: "100%",
                            marginBottom: "1rem",
                          }}
                        />
                      ))}
                    </>
                  ) : (
                    <>
                    {classDetails?.students?.length === 0 ? (
                      <p className="text-base text-appcolorblackfainteleven">
                        Leaderboard data currently unavailable
                      </p>
                    ) : (
                      classDetails?.students?.map((item: any, index: number) => (
                        <div
                          key={`leader-${item._id}`}
                          className={`mb-0 flex items-center justify-between p-4 hover:rounded-[10px] hover:bg-appcolororangefaint`}
                        >
                          
                          <div className="flex items-center">
                            <p className="mr-2 rounded-[7px] bg-appcolorpurplefour px-[0.6rem] py-[0.2rem] text-appcolorwhite">
                              {index + 1}
                            </p>
                  
                            <div className="flex items-center">
                              <Avatar
                                src={`${
                                  item?.userAvatarURL === undefined
                                    ? "/img/vectors/userfemale.svg"
                                    : item?.userAvatarURL === ""
                                    ? "/img/vectors/userfemale.svg"
                                    : item?.userAvatarURL
                                }`}
                                style={{
                                  border: "2px solid #FBE0FF",
                                  borderRadius: "50%",
                                  width: "3rem",
                                  height: "3rem",
                                }}
                              />
                  
                              <div className="ml-3">
                                <p className="mb-1 text-base font-semibold text-appcolorblack">
                                  {item.firstName}
                                </p>
                                <p className="text-base font-semibold text-appcolorblack opacity-[0.5]">
                                  {item.lastName}
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* Additional content */}
                        </div>
                      ))
                    )}
                  </>
                  
                  )}
                </div>
              </div>
            </div>
          </Col>
          <Col xs={24} md={24} lg={12}>
            <div className="mb-10 max-h-[90vh] min-h-[90vh] overflow-auto border-l border-appcolorpurplefaintone pb-10 pl-10">
              <p className="mb-4 text-lg font-bold text-appcolorgrey">
                Curriculum
              </p>

              {loading || loadingAssignment ? (
                <Skeleton.Button
                  active={true}
                  size={"large"}
                  shape={"square"}
                  block={true}
                  style={{
                    height: "10rem",
                    width: "100%",
                  }}
                />
              ): classCurriculumAssignment.length===0 ? (
                <p className="text-base text-appcolorblackfainteleven">
                  No curriculum assigned yet
                </p>
              ) : (
                <>
                  <Tabs
                    defaultActiveKey={currentCurriculumId}
                    items={classCurriculumAssignment}
                    onChange={(key: string) => {
                      setCurrentCurriculumId(key);
                      setDefaultCurriculum(key);
                    }}
                  />

                  {loadingCurriculumDetails || curriculumMainDetails == null ? (
                    <Curriculumloader hasBottom={false} />
                  ) : (
                    <>
                      <div className="flex items-center justify-between">
                        <p className="text-base font-[900] capitalize text-appcolorpurplefaintone">
                          {curriculumMainDetails?.name ?? "Hello"}
                        </p>


                        <div className="relative ml-2 items-center rounded-[1rem] bg-appcolorlightgreenfour px-3 py-1">
                          <p className="relative z-[1] text-sm font-medium text-appcolorgreenfive">
                            {curriculumMainDetails?.progressId
                              ?.completionPercentage ?? 0}
                            % completed
                          </p>
                          <div
                            className="absolute top-0 left-0 bg-appcolorlightgreenthree"
                            style={{
                              width: `${
                                curriculumMainDetails?.progressId
                                  ?.completionPercentage ?? 0
                              }%`,
                              height: "1.7rem",
                              borderTopRightRadius:
                                curriculumMainDetails?.progressId
                                  ?.completionPercentage === 100
                                  ? "1rem"
                                  : 0,
                              borderBottomRightRadius:
                                curriculumMainDetails?.progressId
                                  ?.completionPercentage === 100
                                  ? "1rem"
                                  : 0,
                              borderTopLeftRadius: "1rem",
                              borderBottomLeftRadius: "1rem",
                            }}
                          />
                        </div>
                      </div>

                      <div className="mt-4 flex border-t-[0.3px] border-appcolorpurplefaintone pt-4">
                        <div className="flex-grow">
                          <Row gutter={8}>
                            <Col xs={24} md={24} lg={12}>
                              <div className="flex mb-2 curriculumDetailss-center">
                                <img
                                  src="/img/vectors/purpletime.svg"
                                  alt="users"
                                  className="w-5 h-5 mr-1"
                                />

                                <div className="flex curriculumDetailss-center">
                                  <p className="pr-1 text-sm font-extrabold text-appcolorpurplefaintone">
                                    {curriculumMainDetails?.duration}
                                  </p>
                                  <p className="text-xs text-appcolorpurplefaintone">
                                    {curriculumMainDetails?.durationUnit}
                                    {curriculumMainDetails?.duration > 1
                                      ? "s"
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            </Col>
                            <Col xs={24} md={24} lg={12}>
                              <div className="flex mb-2 curriculumDetailss-center">
                                <img
                                  src="/img/vectors/purpleminmod.svg"
                                  alt="users"
                                  className="w-5 h-5 mr-1"
                                />

                                <div className="flex curriculumDetailss-center">
                                  <p className="pr-1 text-sm font-extrabold text-appcolorpurplefaintone">
                                    2
                                  </p>
                                  <p className="text-xs text-appcolorpurplefaintone">
                                    min/module
                                  </p>
                                </div>
                              </div>
                            </Col>
                            <Col xs={24} md={24} lg={12}>
                              <div className="flex mb-2 curriculumDetailss-center">
                                <img
                                  src="/img/vectors/purpledocument.svg"
                                  alt="users"
                                  className="w-5 h-5 mr-1"
                                />

                                <div className="flex curriculumDetailss-center">
                                  <p className="pr-1 text-sm font-extrabold text-appcolorpurplefaintone">
                                    0
                                  </p>
                                  <p className="text-xs text-appcolorpurplefaintone">
                                    assignments
                                  </p>
                                </div>
                              </div>
                            </Col>
                            <Col xs={24} md={24} lg={12}>
                              <div className="flex curriculumDetailss-center">
                                <img
                                  src="/img/vectors/purpleplans.svg"
                                  alt="users"
                                  className="w-5 h-5 mr-1"
                                />
                                <div className="flex curriculumDetailss-center">
                                  <p className="pr-1 text-sm font-extrabold text-appcolorpurplefaintone">
                                    {curriculumMainDetails?.lessonPlans?.length}
                                  </p>
                                  <p className="text-xs text-appcolorpurplefaintone">
                                    lesson plan
                                    {curriculumMainDetails?.lessonPlans
                                      ?.length > 1
                                      ? "s"
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <div>
                        {curriculumMainDetails?.data?.map(
                          (item: any, index: number) => (
                            <Modulegroup
                              key={item?._id}
                              details={item}
                              index={index}
                              openLevel={openLevel}
                            />
                          )
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Studentclass;
